import { useRouter } from 'next/router';

export const useAnalyticsData = () => {
  const { query } = useRouter();
  const { type } = query;

  let pageType = 'search results';

  if (type === 'browse' || type === 'brand') {
    pageType = 'product list page grid';
  }

  return {
    pageType,
  };
};
